import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { Collapse } from "react-bootstrap";
import UnForm from "../../../Components/Form";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import StickyToolbar from "../../../Components/StickyToolbar";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import { GetProdutosPorUnidadeEquipeController } from "../../../Controllers/Vendas/PainelImplantacao/PainelImplantacaoControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IProdutoPainelImplantacao } from "../../../Interfaces/Vendas/PainelImplantacao/PainelImplantacaoInterface";
import { groupBy } from "../../../Tools/ProcessingTools";
import ModalDetalheProduto from "../PainelImplantacao/ModalDetalheProduto";

interface IEspelhoVendasProps {}
interface IFiltroEmpreendimento {
    idEmpreendimento: number;
}

type TStatusVenda =
    | "DISPONÍVEL"
    | "RESERVADO"
    | "VENDIDO"
    | "PERMUTADO"
    | "FORA VENDA"
    | "SUSPENSO";

const CoresDosProdutos = {
    DISPONÍVEL: {
        bg: "bg-success",
        text: "text-white",
        bgAndText: "bg-success text-white",
    },
    VENDIDO: {
        bg: "bg-danger",
        text: "text-white",
        bgAndText: "bg-danger text-white",
    },
    RESERVADO: {
        bg: "bg-warning",
        text: "text-white",
        bgAndText: "bg-warning text-white",
    },
    PERMUTADO: {
        bg: "bg-primary",
        text: "text-white",
        bgAndText: "bg-primary text-white",
    },
    "FORA VENDA": {
        bg: "bg-info",
        text: "text-white",
        bgAndText: "bg-info text-white",
    },
    SUSPENSO: {
        bg: "bg-secondary",
        text: "text-dark",
        bgAndText: "bg-secondary text-dark",
    },
    "TOTAL UNIDADES": {
        bg: "bg-light-dark",
        text: "text-dark",
        bgAndText: "bg-light-dark text-dark",
    },
};

export default function EspelhoVendas(props: IEspelhoVendasProps) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        execute: getProdutosPorUnidadeEquipe,
        loading: getProdutosPorUnidadeEquipeLoading,
        value: produtosPorUnidadeEquipe,
    } = useAsyncCallback(GetProdutosPorUnidadeEquipeController);

    const [legenda, setLegenda] = useState(true);

    const STATUS = useMemo(() => {
        const obj = {
            DISPONÍVEL: 0,
            RESERVADO: 0,
            VENDIDO: 0,
            PERMUTADO: 0,
            "FORA VENDA": 0,
            SUSPENSO: 0,
            TOTAL: 0,
        };
        function SomarNumerosLegenda() {
            produtosPorUnidadeEquipe?.forEach((value) => {
                obj[value.DS_STATUS as TStatusVenda]++;
            });
        }

        function TotalUnidades() {
            const totalValue = Object.values(obj).reduce(function (
                previousValue,
                currentValue
            ) {
                return previousValue + currentValue;
            });
            return totalValue;
        }

        SomarNumerosLegenda();
        obj.TOTAL = TotalUnidades();
        return obj;
    }, [produtosPorUnidadeEquipe]);

    function getEmpreendimento(formData: IFiltroEmpreendimento) {
        getProdutosPorUnidadeEquipe(formData.idEmpreendimento);
    }

    function groupByBloco() {
        if (produtosPorUnidadeEquipe) {
            return Array.from(
                groupBy(
                    produtosPorUnidadeEquipe,
                    (value) => value.DS_BLOCO
                ).entries()
            );
        }
    }

    function groupByAndar(array: IProdutoPainelImplantacao[] | undefined) {
        if (array) {
            return Array.from(
                groupBy(array, (value) => value.NR_ANDAR.toString()).entries()
            );
        }
    }

    return (
        <div className="col-12 d-flex justify-content-between align-items-center flex-column">
            <header className="col-12 d-flex flex-column justify-content-center align-items-center border border-dark rounded mb-10 card card-custom g-2">
                <h3>Empreendimento</h3>
                <div className="d-flex justify-content-between flex-column">
                    <Collapse in={legenda} mountOnEnter unmountOnExit>
                        <div className="d-flex align-items-center m-3 flex-wrap">
                            <div
                                className={`border d-flex justify-content-center align-items-center border-dark p-10 ${CoresDosProdutos["DISPONÍVEL"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Disponivel: {STATUS.DISPONÍVEL}
                            </div>
                            <div
                                className={`border d-flex justify-content-center align-items-center border-dark p-10 ${CoresDosProdutos["RESERVADO"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Reservado: {STATUS.RESERVADO}
                            </div>
                            <div
                                className={`border d-flex justify-content-center text-white align-items-center border-dark p-10 ${CoresDosProdutos["VENDIDO"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Vendido: {STATUS.VENDIDO}
                            </div>
                            <div
                                className={`border d-flex justify-content-center text-white align-items-center border-dark p-10 ${CoresDosProdutos["PERMUTADO"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Permutado: {STATUS.PERMUTADO}
                            </div>
                            <div
                                className={`border d-flex text-white justify-content-center align-items-center border-dark p-10 ${CoresDosProdutos["FORA VENDA"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Fora Venda: {STATUS["FORA VENDA"]}
                            </div>
                            <div
                                className={`border d-flex justify-content-center align-items-center border-dark p-10 ${CoresDosProdutos["SUSPENSO"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Suspenso: {STATUS.SUSPENSO}
                            </div>
                            <div
                                className={`border d-flex justify-content-center align-items-center border-dark p-10 ${CoresDosProdutos["TOTAL UNIDADES"].bgAndText}`}
                                style={{
                                    maxHeight: 70,
                                    maxWidth: 90,
                                }}
                            >
                                Total de Unidades: {STATUS.TOTAL}
                            </div>
                        </div>
                    </Collapse>
                    <button
                        onClick={() => setLegenda((prev) => !prev)}
                        style={{ background: "none", border: "none" }}
                    >
                        <FontAwesomeIcon
                            icon={legenda ? faAngleDown : faAngleUp}
                        />
                    </button>
                </div>
            </header>

            {produtosPorUnidadeEquipe && STATUS.TOTAL !== 0 ? (
                <main className="p-4 col-12">
                    <div className="col-12 d-flex flex-wrap justify-content-around container">
                        {groupByBloco()?.map(([bloco, produtos]) => (
                            <ul
                                className={`d-flex col-12 col-lg-6 mb-5 p-5 card card-custom m-1`}
                                style={{
                                    maxWidth: 800,
                                    listStyle: "none",
                                }}
                            >
                                <div className="col-12">
                                    <div
                                        className="d-flex align-items-center col-12 card-header p-5"
                                        style={{ maxHeight: 50 }}
                                    >
                                        <h3 className="col-12">
                                            Bloco: {bloco}
                                        </h3>
                                    </div>
                                    <div className="col-12 d-flex d-flex flex-wrap p-2">
                                        {groupByAndar(produtos)?.map(
                                            ([andares, apartamentos]) => (
                                                <div className="col-12 d-flex align-items-center text-center justify-content-around flex-wrap mb-3 carousel slide">
                                                    {apartamentos.map(
                                                        (apartamento) => (
                                                            <span
                                                                onClick={() => {
                                                                    setModal({
                                                                        Component:
                                                                            () => (
                                                                                <ModalDetalheProduto
                                                                                    produto={
                                                                                        apartamento
                                                                                    }
                                                                                    setShow={
                                                                                        setShow
                                                                                    }
                                                                                />
                                                                            ),
                                                                        IconHeader:
                                                                            faProductHunt,
                                                                        headerComponent:
                                                                            "Evento",
                                                                        noHeader:
                                                                            true,
                                                                        noFooter:
                                                                            true,
                                                                        size: "lg",
                                                                    });
                                                                    setShow(
                                                                        true
                                                                    );
                                                                }}
                                                                key={
                                                                    apartamento.ID_CHAVE_ERP
                                                                }
                                                                className={`d-flex col-6 col-sm-2 cursor-pointer  align-items-center border ${
                                                                    CoresDosProdutos[
                                                                        apartamento.DS_STATUS as TStatusVenda
                                                                    ]?.bg
                                                                } p-2 text-center`}
                                                                style={{
                                                                    height: 70,

                                                                    width: "100%",
                                                                }}
                                                            >
                                                                {
                                                                    apartamento.DS_PRODUTO
                                                                }
                                                            </span>
                                                        )
                                                    )}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </ul>
                        ))}
                    </div>
                </main>
            ) : (
                <>
                    <span>
                        Este empreendimento não possui mapa de implantação
                        disponível
                    </span>
                </>
            )}

            <StickyToolbar inicialyOpenned={true}>
                <UnForm handleSubmit={getEmpreendimento}>
                    <div className="form-group row">
                        <div className="col-12">
                            <UnForm.LazySelect
                                label="Empreendimento"
                                controller={ListarEmpreendimentosController}
                                getDS={(e) => e.DS_EMPREENDIMENTO}
                                getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                                disabled={getProdutosPorUnidadeEquipeLoading}
                                name="idEmpreendimento"
                                onChange={(event) => {
                                    getEmpreendimento({
                                        idEmpreendimento: Number(
                                            event.target.value
                                        ),
                                    });
                                }}
                            >
                                <OrSpinner
                                    loadingSize="sm"
                                    spinner="default"
                                    loading={getProdutosPorUnidadeEquipeLoading}
                                >
                                    <option />
                                </OrSpinner>
                            </UnForm.LazySelect>
                        </div>
                    </div>
                </UnForm>
            </StickyToolbar>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
